module.exports = __webpack_public_path__ + "static/media/CamelCase.d924f2a4.PNG";